import { ConversationsList } from "./chatbot-tabs/ConversationsTab";
import { useSession } from "@/contexts/SessionContext";
import type { Role } from "@chat-yai/shared";

// Workspace-wide conversations inbox. Surfaces every chatbot's conversations
// in one place so triage roles (Owner / Admin / Support) don't have to bounce
// between chatbot detail pages. Re-uses ConversationsList in "global" mode
// (no chatbotId filter).
export function ConversationsPage(): JSX.Element {
  const { me } = useSession();
  const role: Role =
    me?.memberships.find((m) => m.tenant_id === me.current_tenant_id)?.role ??
    "viewer";

  return (
    <div className="page" data-testid="conversations-page">
      <div className="page-head">
        <div>
          <div className="page-title">Conversations</div>
          <div className="page-sub">
            Triage every chat from your workspace, mark as read, change status
            and reassign teammates.
          </div>
        </div>
      </div>
      <ConversationsList role={role} />
    </div>
  );
}
